"use client";

import Section3Page from "../section3";

export default Section3Page;
